import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rds:output-empty-state',
  templateUrl: './output-empty-state.component.html',
  styleUrls: ['./output-empty-state.component.scss']
})
export class OutputEmptyStateComponent implements OnInit {

  @Input() title:string = '404';
  @Input() description:string = '';
  @Input() customImage:string = "";
  @Input() emptyState:string = "not-found";
  @Input() imageSize:string = "md";//img-fluid, sm, md, xl
  @Input() textPosition:string = "bottom";
  @Input() prefixLink:string = "";
  @Input() prefixLabel:string = "";
  @Input() subfixLink:string = "";
  @Input() subfixLabel:string = "";

  svgPath:string = 'https://api-v1.finex-cambodia.io/img/svg';
  defaultEmptyImage:string = "";

  errorStateMapping:any = {
    "empty-order" : this.svgPath + "/make-order.svg",
    "empty-chart" : this.svgPath + "/empty-chart.svg",
    "under-maintenance" : this.svgPath + "/empty-street.svg",
    "error-404" : this.svgPath + "/error-404.svg",
    "error-401" : this.svgPath + "/error-401.svg",
    "error-500": this.svgPath + "/error-500.svg",
    "error-503": this.svgPath + "/error-503.svg",
    "not-found" : this.svgPath + "/search.svg",
  };
  constructor() { }

  ngOnInit() {
    this.defaultEmptyImage = this.errorStateMapping["not-found"];
  }

}
